import type { SVGProps } from 'react';
const SvgProjectPage1 = (props: SVGProps<SVGSVGElement>) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={100}
      fill="none"
      className="w-full h-full"
      viewBox="0 0 100 100"
      {...props}
   >
      <rect
         className="stroke-primary"
         x="51.8313"
         y="59.5421"
         width="36.1687"
         height="28.5542"
         rx="7"
         stroke="black"
         strokeWidth="5"
      />
      <path
         className="stroke-primary"
         d="M74.9613 72.9406C75.658 73.3192 75.658 74.3194 74.9613 74.698L65.9202 79.6108C65.2539 79.9729 64.4428 79.4905 64.4428 78.7321L64.4428 68.9065C64.4428 68.1481 65.2539 67.6657 65.9202 68.0278L74.9613 72.9406Z"
         stroke="black"
         strokeWidth="4"
         strokeLinejoin="round"
      />
      <rect
         className="stroke-primary"
         x="56.5903"
         y="12.9036"
         width="28.5542"
         height="38.0723"
         rx="7"
         stroke="black"
         strokeWidth="5"
      />
      <path
         className="stroke-primary"
         d="M64.2048 42.4097H75.6265"
         stroke="black"
         strokeWidth="4"
         strokeLinecap="round"
      />
      <path
         className="stroke-primary"
         d="M64.2048 28.1326H77.5301"
         stroke="black"
         strokeWidth="4"
         strokeLinecap="round"
      />
      <path
         className="stroke-primary"
         d="M64.2048 35.7469H71.8193"
         stroke="black"
         strokeWidth="4"
         strokeLinecap="round"
      />
      <path
         className="stroke-primary"
         d="M64.2048 21.4698H74.6747"
         stroke="black"
         strokeWidth="4"
         strokeLinecap="round"
      />
      <rect
         className="stroke-primary"
         x="11.8554"
         y="15.759"
         width="35.2169"
         height="33.3133"
         rx="7"
         stroke="black"
         strokeWidth="5"
      />
      <path
         className="stroke-primary"
         d="M20.4217 40.506L25.9577 34.7952L31.4937 40.506L35.1844 36.6988L38.506 40.506"
         stroke="black"
         strokeWidth="5"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
      <circle
         className="stroke-primary"
         cx="34.6988"
         cy="26.2289"
         r="3.80723"
         stroke="black"
         strokeWidth="4"
      />
      <circle
         className="stroke-primary"
         cx="27"
         cy="74"
         r="16"
         stroke="black"
         strokeWidth="5"
      />
      <path
         className="stroke-primary"
         d="M21 74.5L25.2353 78L33 71"
         stroke="black"
         strokeWidth="5"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
);
export default SvgProjectPage1;
